import Header from "../components/Header/header";
import Hero from "../components/Hero/hero";
import Studio from "../components/Studio/studio";
// import Team from "../components/Team/WhyOneTeam"
import OneTeam from "../components/OneTeam/OneTeam"
// import Howitworks from "../components/Howitworks/HowItWorks"
import Howitworks from "../components/Howitworks/HowItWorksV2"
import Interiorcomparison from "../components/Compare/InteriorComparison"
import Workshopsitesection from "../components/Whereyou/WorkshopSiteSection"
import Projects from "../components/Projects/ProjectsGrid"
import Whatwedo from "../components/Whatwedo/WhatWeDo"
import PlanningCTA from "../components/PlanningCTA/PlanningCTA"
import Footer from "../components/Footer/Footer"

export default function Home() {
  return (
    <div className="shell">
      <Header />
      <main>
        <Hero />
        <Studio />
        {/* <Team /> */}
        <OneTeam />
        <Howitworks/>
        {/* <Interiorcomparison />
        <Workshopsitesection /> */}
        <Projects/>
        <Whatwedo/>
        <PlanningCTA />
        
      </main>
      <Footer />
    </div>
  );
}
